import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import LangRu from '@/components/icons/LangRu.vue';
import LangEn from '@/components/icons/LangEn.vue';
import LangFr from '@/components/icons/LangFr.vue';
import LangHy from '@/components/icons/LangHy.vue';

interface Props {
  lang: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LangIcon',
  props: {
    lang: { default: 'ru' }
  },
  setup(__props: any) {

const languageComponents = {
  ru: LangRu,
  en: LangEn,
  fr: LangFr,
  hy: LangHy,
};

const props = __props;

const component = computed(() => languageComponents[props.lang]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), { class: "lang-icon" }))
}
}

})